import React, { useContext, useMemo } from 'react';
import { Tooltip } from '@usealloy/component-library';
import {
  StyledGreenDot, StyledOutputBadge, StyledOutputText, StyledOutputBadgeAndDot,
} from './styles';
import type { ThresholdResult } from 'flow/store/engine/types/workflowFeatures';
import { ThresholdContext } from '../context';
import { getDollarCurrencyRightAttributeValueMode } from '../helpers';
import { RuleEditorContext } from '../../NodeEditorDrawer/context';

type RuleLineItemOutputValueProps = {
  thresholdResult: ThresholdResult;
  showEvidenceButton: boolean;
};

const RuleLineItemOutputValue = ({
  thresholdResult,
  showEvidenceButton,
}: RuleLineItemOutputValueProps) => {
  const { simpleEditorMode } = useContext(RuleEditorContext);
  const { threshold } = useContext(ThresholdContext);

  const dollarCurrencyRightAttributeValueMode = useMemo(() => (
    getDollarCurrencyRightAttributeValueMode(threshold?.left)
  ), [threshold?.left]);

  const outputValue = thresholdResult?.is_tag_set !== null
    ? `${thresholdResult?.is_tag_set ? 'Set' : 'Not Set'}`
    : `${thresholdResult?.left_value ?? 'No output value'}`;

  const tooltipContent = thresholdResult?.is_true
    ? `Satisfies logic: ${outputValue}`
    : `Does not satisfy logic: ${outputValue}`;

  return (
    <StyledOutputBadgeAndDot
      gap={1}
      alignItems="center"
      justifyContent="flex-start"
      showEvidenceButton={showEvidenceButton}
    >
      <StyledGreenDot isVisible={thresholdResult?.is_true} />
      <Tooltip
        content={tooltipContent}
        side="top"
        style={{
          wordBreak: 'break-all',
        }}
      >
        {!simpleEditorMode && (
          <StyledOutputBadge satisfiesLogic={thresholdResult?.is_true}>
            <StyledOutputText>
              {dollarCurrencyRightAttributeValueMode
                ? `$${(parseInt(outputValue, 10) / 100).toFixed(2)}`
                : `${outputValue}`}
            </StyledOutputText>
          </StyledOutputBadge>
        )}
      </Tooltip>
    </StyledOutputBadgeAndDot>
  );
};

export default RuleLineItemOutputValue;
